import cc from 'classcat'

import { getCustomColorStyleVars, useImageColorSettings } from '../../../../../utils/hooks/colorSettings'

type TextSettings = {
  headline?: string
  text?: string
  buttontext?: string
  buttonenabled?: boolean
}

type OverlaySettings = {
  overlayWidth: number
  overlayBlur: boolean
}

type LayoutSettings = {
  layout: string
  layoutSide: string
}

export type HeroImageOverlayProps = Readonly<{
  textSettings: TextSettings
  image: ImmutableMap
  overlaySettings: OverlaySettings
  layoutSettings: LayoutSettings
}>

export default function HeroImageOverlay({
  textSettings,
  image,
  overlaySettings,
  layoutSettings,
}: HeroImageOverlayProps) {
  const { headline, text, buttontext, buttonenabled } = textSettings
  const { textColor, buttonColor, backgroundColor, overlayOpacity } = useImageColorSettings(image)
  const { overlayWidth, overlayBlur } = overlaySettings
  const { layout, layoutSide } = layoutSettings

  const isButtonRenders = buttontext && buttonenabled

  if (!(headline || text || isButtonRenders)) {
    return null
  }

  return (
    <div
      className={cc(['overlay', 'overlay-' + layout, overlayBlur && 'blur'])}
      data-overlay-color={backgroundColor.get('name')}
      data-text-color={textColor.get('name')}
      data-button-color={buttonColor.get('name')}
      style={{
        '--overlay-width': overlayWidth + '%',
        ...getCustomColorStyleVars({ textColor, buttonColor, backgroundColor }),
      }}
    >
      {(headline || text || isButtonRenders) &&
        (layout === 'diagonal' ? (
          <div className={`${layoutSide}-wrapper`}>
            {headline && <h2 className="headline">{headline}</h2>}
            {text && <p className="text">{text}</p>}
            {isButtonRenders && <button className="button">{buttontext}</button>}
          </div>
        ) : (
          <>
            {headline && <h2 className="headline">{headline}</h2>}
            {text && <p className="text">{text}</p>}
            {isButtonRenders && <button className="button">{buttontext}</button>}
          </>
        ))}
      <div className="overlay-background" style={{ opacity: overlayOpacity / 100 }}></div>
    </div>
  )
}
